import requestErrorHandler from 'ca-request/requestErrorHandler';

export const notifySavingError = (
  error: Error | XMLHttpRequest,
  action: string,
  requestGroup: string,
  userMessage: string
) => {
  // Log to Bugsnag
  requestErrorHandler(error, { answerUrl: action }, requestGroup);

  // Alert user
  alert(userMessage);
};

export default notifySavingError;
